
import { useState, useEffect } from 'react';

export default function HeroSection() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8 relative">
      <div className="max-w-7xl mx-auto text-center">
        <div className={`transform transition-all duration-1500 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
          <h1 className="text-4xl sm:text-6xl lg:text-8xl font-bold text-white mb-6 tracking-tight">
            <span className="bg-gradient-to-r from-blue-400 via-purple-400 to-cyan-400 bg-clip-text text-transparent">
              Cyber Security
            </span>
            <br />
            <span className="text-white">Solutions</span>
          </h1>
          
          <p className="text-xl sm:text-2xl lg:text-3xl text-gray-300 mb-12 max-w-4xl mx-auto leading-relaxed">
            Comprehensive protection for your digital infrastructure with cutting-edge security technologies
          </p>

          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <button className="group relative px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white font-semibold rounded-full hover:from-blue-700 hover:to-purple-700 transform hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-2xl">
              <span className="relative z-10">Get Protected Now</span>
              <div className="absolute inset-0 bg-gradient-to-r from-blue-400 to-purple-400 rounded-full opacity-0 group-hover:opacity-50 transition-opacity duration-300"></div>
            </button>
            
            <button className="group px-8 py-4 border-2 border-cyan-400 text-cyan-400 font-semibold rounded-full hover:bg-cyan-400 hover:text-slate-900 transform hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer">
              Security Assessment
            </button>
          </div>
        </div>

        {/* 3D Security Shield Model */}
        <div className="mt-16 relative">
          <div className="w-32 h-32 sm:w-48 sm:h-48 lg:w-64 lg:h-64 mx-auto relative">
            <img 
              src="https://readdy.ai/api/search-image?query=3D%20rendered%20cybersecurity%20shield%20icon%20floating%20in%20space%2C%20metallic%20blue%20and%20silver%20materials%2C%20glowing%20edges%20with%20neon%20accents%2C%20professional%20security%20symbol%2C%20transparent%20background%2C%20high-quality%203D%20model%20with%20realistic%20lighting%20and%20reflections%2C%20modern%20tech%20aesthetic&width=512&height=512&seq=shield3d&orientation=squarish"
              alt="3D Security Shield"
              className="w-full h-full object-contain animate-pulse hover:animate-spin transition-all duration-1000 cursor-pointer"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-blue-400/20 to-purple-400/20 rounded-full blur-xl animate-pulse"></div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl"></i>
      </div>
    </section>
  );
}
